import { supabase } from "@/integrations/supabase/client";
import { getStripeEnvironment } from "@/lib/stripe";
import { toast } from "sonner";

/** Open the Stripe Billing Portal in a new tab. Returns true on success. */
export async function openBillingPortal(): Promise<boolean> {
  try {
    const { data, error } = await supabase.functions.invoke("create-portal-session", {
      body: {
        returnUrl: `${window.location.origin}/settings`,
        environment: getStripeEnvironment(),
      },
    });
    if (error || !data?.url) throw new Error(error?.message || "Could not open billing portal");
    window.open(data.url, "_blank", "noopener,noreferrer");
    return true;
  } catch (e) {
    toast.error((e as Error)?.message || "Could not open billing portal");
    return false;
  }
}
